// @ts-nocheck
import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  forwardRef,
} from '@angular/core';
import { NgTryForDirective } from '../../../../../directives/_old_directives/ng-try-for.directive';
import { AddressListComponent } from '../../../fields/address-list/address-list.component';
import { CommentForumComponent } from '../../../fields/comment-forum/comment-forum.component';
import { DatePickerComponent } from '../../../fields/date-picker/date-picker.component';
import { DateTimePickerComponent } from '../../../fields/date-time-picker/date-time-picker.component';
import { FileFromProcessComponent } from '../../../fields/file-from-process/file-from-process.component';
import { GridboxUniqueComponent } from '../../../fields/gridbox-unique/gridbox-unique.component';
import { GridboxComponent } from '../../../fields/gridbox/gridbox.component';
import { InputHiddenComponent } from '../../../fields/input-hidden/input-hidden.component';
import { InputProcessNumberComponent } from '../../../fields/input-process-number/input-process-number.component';
import { InputReferenceComponent } from '../../../fields/input-reference/input-reference.component';
import { InputTextCondensedComponent } from '../../../fields/input-text-condensed/input-text-condensed.component';
import { InputTextComponent } from '../../../fields/input-text/input-text.component';
import { MessageFieldComponent } from '../../../fields/message-field/message-field.component';
import { OabComponent } from '../../../fields/oab/oab.component';
import { SelectTreeCondensedComponent } from '../../../fields/select-tree-condensed/select-tree-condensed.component';
import { SelectTreeComponent } from '../../../fields/select-tree/select-tree.component';
import { TableListComponent } from '../../../fields/table-list/table-list.component';
import { TextareaComponent } from '../../../fields/textarea/textarea.component';
import { TimePickerRefComponent } from '../../../fields/timepicker/timepicker.component';
import { TreeTableComponent } from '../../../fields/tree-table/tree-table.component';
import { DynamicFormService } from '../../dynamic-form.service';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { EntityFieldsComponent } from './entity-fields/entity-fields.component';

@Component({
  selector: 'lbca-sub-module-form',
  templateUrl: './subform.component.html',
  styleUrl: './subform.component.scss',
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [
    NgTemplateOutlet,
    NgTryForDirective,
    NgClass,
    InputHiddenComponent,
    forwardRef(() => InputTextComponent),
    InputProcessNumberComponent,
    forwardRef(() => InputReferenceComponent),
    forwardRef(() => InputTextCondensedComponent),
    forwardRef(() => TextareaComponent),
    forwardRef(() => DateTimePickerComponent),
    forwardRef(() => DatePickerComponent),
    forwardRef(() => TimePickerRefComponent),
    forwardRef(() => TreeTableComponent),
    forwardRef(() => EntityFieldsComponent),
    forwardRef(() => SelectTreeCondensedComponent),
    forwardRef(() => SelectTreeComponent),
    forwardRef(() => GridboxComponent),
    forwardRef(() => GridboxUniqueComponent),
    forwardRef(() => AddressListComponent),
    forwardRef(() => TableListComponent),
    forwardRef(() => OabComponent),
    forwardRef(() => CommentForumComponent),
    forwardRef(() => MessageFieldComponent),
    forwardRef(() => FileUploadComponent),
    forwardRef(() => FileFromProcessComponent),
  ],
})
export class SubModuleFormComponent implements OnInit {
  @ViewChild('dynamicFormData') dynamicFormData!: TemplateRef<any>;

  @Output() setControlCloud = new EventEmitter<string>();

  public properties: any;
  public data: any = {};

  public controllDataSubForm: any;

  public cardInfo: any;

  error = {};

  someoneDepentOfMe = false;
  disabedControll = false;

  dependent;
  subFormModuleInstance = null;
  gridFormModuleInstance = null;

  public errorApiForm = null;

  public formType: 'form-primary' | 'modal' | 'form-secondary' = 'form-primary';

  public callDynamicForm = false;

  public dynamicData: any = [];

  private subscription!: any;

  public initialized = false;

  public isOpen = false;
  public flowId = '';

  @Input() set type(type: 'form-primary' | 'modal' | 'form-secondary') {
    this.formType = type;
  }
  @Input('dynamicForm') set setDynamicData(form: any) {
    this.dynamicData = form;
  }
  @Input('error') set err(error) {
    this.error = error;
  }
  @Input('properties') set modulesData(prop) {
    this.properties = prop;
  }
  @Input('flowId') set flow(id) {
    this.flowId = id;
  }
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }

  public dataAttr;
  @Input('dataAttr') set dataAt(data) {
    this.dataAttr = data;
  }
  public context;
  @Input('context') set contextSetter(data) {
    this.context = data;
  }

  @Input('externalData') set externalDataValue(data) {
    // this.data = { ...this.data, ...data};
  }

  @Input('entityData') set modulesConfig(data) {
    this.data = data;
  }

  @Input('subFormModuleInstance') set subFormModuleInstanceController(fn) {
    this.subFormModuleInstance = fn;
  }
  @Input('gridFormModuleInstance') set gridFormModuleInstanceController(fn) {
    this.gridFormModuleInstance = fn;
  }
  @Input('disabled') set disabledSetter(status: boolean) {
    this.disabedControll = status;
  }
  @Input('initialized') set initializedValue(initialized: boolean) {
    this.initialized = initialized;
  }
  @Input('forceStateOpened') set openStatus(isOpen: boolean) {
    this.isOpen = isOpen;
  }

  @Output('errorApi') errorApiEmmiter = new EventEmitter();
  @Output('saveData') saveDataEmmiter = new EventEmitter();

  public emmiterFeedback;

  public controllData;

  @Output('validateCallback') validateCallbackEmitter = new EventEmitter();

  public dynamicFormService!: DynamicFormService;
  @Input('dynamicFormService') set formServiceSetter(dynamicFormService: DynamicFormService) {
    this.dynamicFormService = dynamicFormService;
    this.emmiterFeedback = dynamicFormService.feedbackEmitter;
    // this.subscription = dynamicFormService.getControllFormEmmiter.subscribe(
    //   subformField => {
    //     this.controllData = { ...subformField };
    //     this.controllReativeDependency(subformField);
    //     this.controllDataSubForm = dynamicFormService.formControlStructure[this.properties.id].fields;
    //   }
    // )
  }

  ngOnInit(): void {
    this.validateCallbackEmitter.emit(this.validationCallback);
  }

  public cloudEmmitter(status): void {
    this.setControlCloud.emit(status);
  }

  public erroApi(event) {
    this.errorApiEmmiter.emit(event);
  }

  public focusState($event, data, entityKey): void {
    if (!$event) {
      // this.saveDataEmmiter.emit({[entityKey]:data});
    }
  }

  public validationCallback = () => {
    Object.keys(this.fieldsValidations).forEach((key) => this.fieldsValidations[key]());
  };

  private fieldsValidations: any = {};

  public setValidationAddressCallback(fn, key) {
    this.fieldsValidations[key] = fn;
  }

  public setDynamicForm($event): void {
    this.callDynamicForm = $event;
  }

  public setFeedbackEmmiter(feed) {
    this.emmiterFeedback.emit(feed);
  }

  private controllReativeDependency(subformField) {
    // this.properties.fields.filter(row => )
    this.properties.fields.forEach((row) =>
      row.forEach((field) => {
        if (field.childrenDependency && field.entityKey === subformField.entityKey) {
          field.childrenDependency.father.forEach((father) => {
            const isInicializated = field.childrenDependency.inicializated;
            const lastProperties = field.childrenDependency.controllDependency;

            if (father.valuesAndConditions || father.properties) {
              let properties;
              if (father.valuesAndConditions) {
                properties = (this.dynamicFormService.formControlStructure as any)[father.module]
                  ?.fields[father.fieldKey]?.value;
              }

              if (father.properties) {
                const checkedData = subformField.properties;
                if (checkedData) {
                  properties = { visible: father.properties.visible };
                  const dynamoData = father.properties.dynamoData;
                  const val = checkedData[dynamoData];
                  (this.subFormModuleInstance as any)(field.entityKey, 'propertiesValued', val);
                  this.data[field.entityKey] = val;
                }
              }

              const controllDependency = properties
                ? properties
                : field.childrenDependency.defaultCondition;

              if (!isInicializated && lastProperties && controllDependency) {
                if (lastProperties.visible && !controllDependency.visible) {
                  field.childrenDependency.controllDependency.exitMotion = true;
                  setTimeout(() => {
                    field.childrenDependency.controllDependency.exitMotion = false;
                    field.childrenDependency.controllDependency = controllDependency;
                  }, 600); // EXIT MOTION TIMEOUT
                } else {
                  field.childrenDependency.controllDependency.exitMotion = false;
                  field.childrenDependency.controllDependency = controllDependency;
                }
              } else {
                field.childrenDependency.controllDependency.exitMotion = false;
                field.childrenDependency.controllDependency = controllDependency;
              }

              if (father.valuesAndConditions) {
                father['auxValue'] = (this.dynamicFormService.formControlStructure as any)[
                  father.module
                ]?.fields[father.fieldKey]?.value;
              }

              if (!isInicializated && lastProperties && controllDependency) {
                if (
                  !(
                    lastProperties.visible === controllDependency.visible &&
                    lastProperties.disabled === controllDependency.disabled
                  )
                ) {
                  (this.subFormModuleInstance as any)(
                    field.entityKey,
                    'visible',
                    controllDependency.visible
                  );

                  // this.subFormModuleInstance(field.entityKey, 'disabled',
                  // field.childrenDependency.controllDependency.disabled);
                  /**Ficou chumbado o courtId */
                  if (!controllDependency.visible) {
                    if (field.entityKey !== 'courtId') {
                      (this.subFormModuleInstance as any)(field.entityKey, 'value', null);
                      this.data[field.entityKey] = null;
                    }
                  }
                }
              }

              if (isInicializated) field.childrenDependency.inicializated = false;
            } else {
              father['auxValue'] = subformField.value;
            }
          });
        }
      })
    );
  }

  saveUpload(event) {
    const value = event.context;
    const entityKey = event.entityKey;
    (this.subFormModuleInstance as any)(entityKey, 'value', value);
  }

  public handlerChangeSecundaryValue(field, $event) {
    if (field.secundarySetKeyConfiguration) {
      this.data[$event.key] = $event?.value ?? null;
      (this.subFormModuleInstance as any)($event.key, 'value', $event.value);
    }
  }
}
